/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsluga sortowania listingu
 *
 * @export
 * @class Sort
 */

export class Sort {
	constructor() {
		this.actualSort = null;
	}
	// ****************************************************************************************************
	// inicjacja sortowania listingu
	// ****************************************************************************************************
	initSort() {
		var that = this;
		if ($('#actualSort').length > 0)
			that.actualSort = $('#actualSort').data('sort');
		else if (that.actualSort === null)
			that.actualSort = 0;
		$('#sortControler').on('hide.bs.dropdown', function (data) {
			var newSort = null;
			if (data.clickEvent !== undefined) { // pozwala na zamknęcie dropmenu po kliknieciu ponownie w button
				newSort = $(data.clickEvent.target).data('sort');
				if (that.actualSort != newSort && newSort !== undefined) {
					that.actualSort = newSort;
					//console.log('newSort:',newSort);
					that.loadProductsListing();
				}
			}
		});
	}
	// ****************************************************************************************************
	// przygotowanie parametru sortowania
	// ****************************************************************************************************
	prepareSortParam() {
		var that = this;
		return '/st-' + that.actualSort;
	}
	// ****************************************************************************************************
	// update linków po sortowaniu
	// ****************************************************************************************************
	updateHrefInLinksAfterSort(linksObjList) {
		var that = this;
		var hrefSplit;
		linksObjList.each(function (i, e) {
			var href = $(e).attr('href');
			if (href.includes('/st-')) {
				href = href.replace(/\/st-([0-9])/, '/st-' + that.actualSort);
			} else {
				if (href.includes('?')) {
					hrefSplit = href.split('?');
					href = hrefSplit[0] + '/st-' + that.actualSort + '?' + hrefSplit[1];
				} else {
					href = href + '/st-' + that.actualSort;
				}
			}
			$(e).attr('href', toolsObj.removeDefaultParameters(toolsObj.fixUrlOrder(href)));
		});
	}
}